import React, { useEffect, useState, useLocation, useContext, useLayoutEffect } from "react";
import { Container, Col, Row, Tab, Tabs, Table } from "react-bootstrap";
import URLstateContext from "../../../provider/CommonContext";
import { format, parseISO } from 'date-fns'
import './CorporateActMar.css'
import { useNavigate } from "react-router-dom";
function CorporateActMar(props, ref) {
    let getCoCode = props.coCode;
    const { BaseURL } = useContext(URLstateContext);
    const [data, setData] = useState([]);
    const [corptype, settype] = useState('Dividend');
    const [databonus, setdatabonus] = useState([]);
    const [datarights, setdatarights] = useState([]);
    const [datasplit, setdatasplit] = useState([]);
    const [nodatafounddiv, setnodatafounddiv] = useState(false);
    const [nodatafoundbonus, setnodatafoundbonus] = useState(false);
    const [nodatafoundsplit, setnodatafoundsplit] = useState(false);
    const [nodatafoundrights, setnodatafoundrights] = useState(false);
    let navigate = useNavigate();

    useEffect(() => {
        const getUrl = BaseURL + "CorporateAction";
        fetch(`${getUrl}/${corptype}/-/-/-/5`)
            .then((response) => response.json())
            .then((data) => {

                setData(data.data);
                setdatabonus(data.data)
                setdatarights(data.data)
                setdatasplit(data.data)
                // console.log(data.data)
            })
            .catch((error) => {
                setdatabonus([]); setnodatafoundbonus(true);
                setdatarights([]); setnodatafoundrights(true);
                // console.log("not found the api");
            });



    }, [corptype, props.coCode]);

    const handleSelect = (key) => {
        if (key === "tabDividend")
            settype('Dividend');
        else if (key === "tabBonus")
            settype('bonus');
        else if (key === "tabRights")
            settype('Rights');
        else if (key === "tabbuyback")
            settype('BuyBack');
    }

    const moreContent = () => {
        if (corptype === "Dividend") {
            navigate("/CorporateAction/Dividend")
        }
        if (corptype === "bonus") {
            navigate("/CorporateAction/Bonus")
        }
        if (corptype === "Rights") {
            navigate("/CorporateAction/Rights")
        }
        if (corptype === "BuyBack") {
            navigate("/CorporateAction/BuyBack-List")
        }
    }

    return (
        <>
            <div className='market-inner-common'>
                <div className='dymarket-header market-header'>
                    <h4>Corporate Action</h4>
                    <span className="moreContent" onClick={moreContent}>See More</span>
                </div>
                <section className="company-fundamental-sectionBack">
                    {/* <Container >
                        <Row>
                            <Col md={12}> */}
                                {/* <h4>Corporate Action Market</h4> */}
                                <Tabs
                                    defaultActiveKey="tabDividend"
                                    transition={true}
                                    id="noanim-tab-example"
                                    className="mb-3" onSelect={(e) => handleSelect(e)}>
                                    <Tab eventKey="tabDividend" title="Dividend">
                                        <div className="CorM-table table-responsive">
                                            <table className="table table-sm table-striped table-bordered table-hover">
                                                <thead className="caheading">
                                                    <tr>
                                                        <th className="text-left">Company Name</th>
                                                        <th className="text-left">Div Type</th>
                                                        <th className="text-right">Div %</th>
                                                        <th className="text-right">Div Amount</th>
                                                        <th className="text-right">Announcement Date</th>
                                                        <th className="text-right">Record Date</th>
                                                        <th className="text-right">Ex-Div Date</th>
                                                        {/* <th>Remark</th> */}
                                                    </tr>
                                                </thead>
                                                <tbody >
                                                    {data && data.map(({ co_name, DividendType, DivPer, AnnouncementDate, RecordDate, DivDate, DivAmount }) => (
                                                        <>
                                                            <tr className="catbldata">

                                                                <td className="text-left">{co_name}</td>
                                                                <td className="text-left">{DividendType}</td>
                                                                <td className="text-right">{DivPer}</td>
                                                                <td className="text-right">{DivAmount}</td>
                                                                <td className="text-right">{(AnnouncementDate != null) ? (format(parseISO(AnnouncementDate), 'dd-MMM-yyyy')) : ''}</td>
                                                                <td className="text-right">{(RecordDate != null) ? (format(parseISO(RecordDate), 'dd-MMM-yyyy')) : ''}</td>
                                                                <td className="text-right">{(DivDate != null) ? (format(parseISO(DivDate), 'dd-MMM-yyyy')) : ''}</td>


                                                            </tr>
                                                        </>
                                                    ))}
                                                    {nodatafounddiv &&
                                                        <tr>
                                                            <td colSpan="5" className="textcenter nodata">No data found for Dividend !!!</td>
                                                        </tr>
                                                    }
                                                </tbody>
                                            </table>
                                        </div>
                                    </Tab>
                                    <Tab eventKey="tabBonus" title="Bonus">
                                        <div className="CorM-table table-responsive">
                                            <Table striped bordered hover size="sm">
                                                <thead className="caheading">
                                                    <tr>

                                                        <th className='text-left'>Company Name</th>
                                                        <th className='text-right'>Ratio</th>
                                                        <th className='text-right'>Record Date</th>
                                                        <th className='text-right'>Ex Date</th>

                                                    </tr>
                                                </thead>
                                                <tbody >
                                                    {databonus && databonus.map(({ BonusDate, RecordDate, BonusRatio, co_name }) => (
                                                        <>
                                                            <tr className="catbldata">
                                                                <td className="text-left">{co_name}</td>
                                                                <td className="text-right">{BonusRatio}</td>
                                                                <td className="text-right"> {(RecordDate != null) ? RecordDate.split('T')[0] : 0}</td>
                                                                <td className="text-right"> {(BonusDate != null) ? BonusDate.split('T')[0] : 0}</td>
                                                            </tr>
                                                        </>
                                                    ))}
                                                    {nodatafoundbonus &&
                                                        <tr>
                                                            <td colSpan="5" className="textcenter nodata">No data found for Bonus !!!</td>
                                                        </tr>
                                                    }
                                                </tbody>
                                            </Table>
                                        </div>
                                    </Tab>
                                    <Tab eventKey="tabRights" title="Rights">
                                        <div className="CorM-table table-responsive">
                                            <Table striped bordered hover size="sm">
                                                <thead className="caheading">
                                                    <tr>
                                                        <th className='text-left'>Company Name</th>
                                                        <th className='text-right'>Premium (&#8377;)</th>
                                                        <th className='text-right'>Ratio</th>
                                                        <th className='text-right'>Record Date</th>
                                                        <th className='text-right'>Ex Date</th>
                                                    </tr>
                                                </thead>
                                                <tbody >
                                                    {datarights && datarights.map(({ co_name, premium, RightsRatio, recorddate, RightDate }) => (
                                                        <>
                                                            <tr className="catbldata">
                                                                <td className="text-left">{co_name}</td>
                                                                <td className="text-right">{premium}</td>
                                                                <td className="text-right">{RightsRatio}</td>
                                                                <td className="text-right">{(recorddate != null) ? (format(parseISO(recorddate), 'dd-MMM-yyyy')) : ''}</td>
                                                                <td className="text-right">{(RightDate != null) ? (format(parseISO(RightDate), 'dd-MMM-yyyy')) : ''}</td>
                                                            </tr>
                                                        </>
                                                    ))}
                                                    {nodatafoundrights &&
                                                        <tr>
                                                            <td colSpan="5" className="textcenter nodata">No data found for Rights !!!</td>
                                                        </tr>
                                                    }
                                                </tbody>
                                            </Table>
                                        </div>
                                    </Tab>
                                    <Tab eventKey="tabbuyback" title="BuyBack">
                                        <div className="CorM-table table-responsive">
                                            <Table striped bordered hover size="sm">
                                                <thead className="caheading">
                                                    <tr>

                                                        <th className='text-left'>Company Name</th>
                                                        <th className='text-right'>Buyback Price </th>
                                                        <th className='text-left'>Buyback Type</th>
                                                        <th className='text-right'>Announcement Date</th>
                                                        <th className='text-right'>Open Date</th>
                                                        <th className='text-right'>Close Date</th>
                                                    </tr>
                                                </thead>
                                                <tbody >
                                                    {datasplit && datasplit.map(({ co_name, maxbuybackprice, offertype, BBFromdate, BBToDate, AnnouncementDate }) => (
                                                        <>
                                                            <tr className="catbldata">
                                                                <td className="text-left">{co_name}</td>
                                                                <td className="text-right">{maxbuybackprice}</td>
                                                                <td className="text-left">{offertype}</td>
                                                                <td className="text-right">{(AnnouncementDate != null) ? (format(parseISO(AnnouncementDate), 'dd-MMM-yyyy')) : ''}</td>
                                                                {/* <th className="textcenter">{format(parseISO(recorddate), 'dd-MMM-yyyy')}</th> */}
                                                                <td className="text-right">{BBFromdate != null ? format(parseISO(BBFromdate), 'dd-MMM-yyyy') : ""}</td>
                                                                <td className="text-right">{BBToDate != null ? format(parseISO(BBToDate), 'dd-MMM-yyyy') : ""}</td>

                                                            </tr>
                                                        </>
                                                    ))}
                                                    {nodatafoundsplit &&
                                                        <tr>
                                                            <td colSpan="5" className="textcenter nodata">No data found for Split !!!</td>
                                                        </tr>
                                                    }
                                                </tbody>
                                            </Table>
                                        </div>
                                    </Tab>
                                </Tabs>

                            {/* </Col>
                        </Row>
                    </Container> */}
                </section>
            </div>
        </>
    );
}

export default CorporateActMar;